import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DynamicSectionMutationKeys } from '../../../keys'
import {
	CreateDynamicSectionRequest,
	CreateDynamicSectionResponse,
} from '../../../type'
import { createDynamicSection } from '../../services'

interface UseMutationCreateDynamicSectionProps {
	payload: CreateDynamicSectionRequest
}

export default function useMutationCreateDynamicSection(
	props?: UseBaseMutationOptions<
		CreateDynamicSectionResponse,
		UseMutationCreateDynamicSectionProps
	>,
) {
	return useMutation({
		mutationKey: [DynamicSectionMutationKeys.CreateDynamicSection],
		mutationFn: (params) => createDynamicSection(params.payload),
		...props,
	})
}
